import { useEffect, useState } from "react";
import api from "@/lib/api";
import { canAccess } from "@/lib/permissions";

// CC-148 — hiring access = hiring role (permissions.js MATRIX.hiring) OR a
// Settings > Roles primary/backup stage owner (server-side check via /hiring/access).
export function useHiringAccess(user) {
  const viaRole = canAccess(user?.role, "hiring") === true;
  const [stageOwner, setStageOwner] = useState(false);
  useEffect(() => {
    if (!user || viaRole) return;
    let live = true;
    api.get("/hiring/access")
      .then((r) => { if (live) setStageOwner(!!r.data?.has_access); })
      .catch(() => { if (live) setStageOwner(false); });
    return () => { live = false; };
  }, [user, viaRole]);
  return viaRole || stageOwner;
}
